<template>
    <div ref="toast" :class="'toast ' + classes">
        <div v-text="text"></div>
        <ion-icon name="close-circle-outline" @click="destroy"></ion-icon>
    </div>
</template>

<script>
    export default {
        props: {
            text: String,
            type: {
                type: String,
                default: 'info'
            },
            showSeconds: {
                type: Number,
                default: 3
            },
            fadeSeconds: {
                type: Number,
                default: 0.5
            }
        },
        mounted() {
            Object.assign(this.$refs.toast.style,{
                "transition-duration": this.fadeSeconds + 's'
            });
            if (this.showSeconds !== -1) {
                setTimeout(this.destroy.bind(this), this.showSeconds * 1000);
            }
        },
        methods: {
            destroy() {
                Object.assign(this.$refs.toast.style,{
                    "opacity": 0
                });

                setTimeout(() => {
                    this.$destroy();
                    this.$el.parentNode.removeChild(this.$el);
                }, this.fadeSeconds * 1000);
            }
        },
        computed: {
            classes() {
                const availableTypes = ['info', 'success', 'error'];
                return ~availableTypes.indexOf(this.type)? this.type : 'info';
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "resources/sass/_variables";

    .toast {
        transition-property: opacity;
        border: 1px solid;
        min-width: 300px;
        max-width: 500px;
        text-align: center;
        padding: 10px 20px;
        opacity: 1;
        position: relative;
        box-shadow: 2px 2px 5px 0 rgba(0,0,0, .3);

        &.success {
            background: $success-background-color;
            border-color: $success-border-color;
            color: $success-text-color;
        }

        &.error {
            background: $error-background-color;
            border-color: $error-border-color;
            color: $error-text-color;
        }

        &.info {
            background: $info-background-color;
            border-color: $info-border-color;
            color: $info-text-color;
        }

        ion-icon {
            position: absolute;
            top: 5px;
            right: 5px;
            cursor: pointer;
        }
    }
</style>
